import { FeatureFlag, isFeatureEnabled } from "./isFeatureEnabled";

export const isFeatureUpgradable = (feature: FeatureFlag) =>
  !isFeatureEnabled(feature);
